import SupervisorView4MTable from "./SupervisorView4MTable";

export default SupervisorView4MTable;
